import React, { useMemo } from 'react';

import { ReactComponent as IconAN } from '../../../assets/icons/icon-answered-new.svg';
import { ReactComponent as IconAV } from '../../../assets/icons/icon-answered-viewed.svg';
import { ReactComponent as IconAO } from '../../../assets/icons/icon-answered-override.svg';
import { ReactComponent as IconUN } from '../../../assets/icons/icon-unanswered-new.svg';
import { ReactComponent as IconUV } from '../../../assets/icons/icon-unanswered-viewed.svg';
import { ReactComponent as IconUX } from '../../../assets/icons/icon-unanswered-empty.svg';
import { ReactComponent as IconAX } from '../../../assets/icons/icon-answered-empty.svg';

const iconMap = {
  A_N: <IconAN />,
  A_V: <IconAV />,
  A_O: <IconAO />,
  U_N: <IconUN />,
  U_V: <IconUV />,
  U_X: <IconUX />,
  A_X: <IconAX />,
};

const getStatusTooltip = (status) => {
  const map = {
    A_N: 'There is a final answer and new suggestions',
    A_V: 'There is a final answer and suggestions have been reviewed',
    A_O: 'The answer has been overwritten floor old',
    U_N: 'No final answer, but there are new suggestions',
    U_V: 'No final answer, suggestions have been reviewed',
    U_X: 'No final answer and suggestions',
    A_X: 'There is a final answer, but no suggestions',
    UNKNOWN: 'Unclear status',
  };
  return map[status] || map.UNKNOWN;
};

export const StatusIcon = React.memo(({ status }) => {
  const icon = iconMap[status];
  const tooltip = getStatusTooltip(status);

  return (
    <div style={{ width: 20, height: 20, flexShrink: 0, fontSize: 20 }} title={tooltip}>
      {icon}
    </div>
  );
});
